<template>
  <div :class="'card ' + typeCard(data.id)">
    <div class="card-header">
      <b class="header-text">{{ namaTraining }}</b>
      <p class="price-text">
        <b>Rp {{ formattedHarga }} </b> <span>/pertemuan</span>
      </p>
    </div>
    <div class="card-body">
      <div v-html="formattedDetails"></div>
      <button class="btn btndftr" @click="goCreate(idJenis)">Daftar</button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

export default {
  name: "CardJenisTraining",
  props: {
    data: "",
    idJenis: "",
    harga: "",
    cardDetail: "",
    namaTraining: "",
    dataList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      detail: this.cardDetail,
    };
  },
  components: {},
  computed: {
    ...mapGetters(moduleName, {
      hargaTraining: "hargaTraining",
    }),
    formattedHarga() {
      return this.harga.toLocaleString("id-ID");
    },
    formattedDetails() {
      return this.processHTML(this.cardDetail);
    },
  },
  methods: {
    goCreate(param_idjenis) {
      this.$store.dispatch(`kampusModule/resetState`);
      this.hargaTraining.harga = this.harga;
      this.$router.push({
        name: "training.create",
        params: { idjenis: param_idjenis },
      });
    },
    typeCard(idJenisTraining) {
      if (idJenisTraining == "free_online") {
        return "yellowCard";
      }
      if (idJenisTraining == "paid_online") {
        return "greenCard";
      }
      if (idJenisTraining == "basic_offline") {
        return "blueCard";
      }
      if (idJenisTraining == "full_offline") {
        return "purpleCard";
      }
    },
    processHTML(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const serializer = new XMLSerializer();
      const formattedHTML = serializer.serializeToString(doc);

      return formattedHTML;
    },
  },
};
</script>

<style>
.card-info {
  display: flex;
  width: 260px /* atau 350px*/;
  padding: 10px 16px;
  border-radius: 5px;
  border: 1px solid var(--others-grey-grey-800, #ccc);
  background: #fff;
  margin-top: 0;
}

.card-disable {
  background: #ccc !important;
}

.yellowCard {
  background: linear-gradient(
    154deg,
    #f2c94c 0%,
    rgba(252, 170, 73, 0.43) 100%
  );
}
.greenCard {
  background: linear-gradient(
    143deg,
    #2f957c 0%,
    rgba(76, 168, 135, 0.43) 100%
  );
}

.blueCard {
  background: linear-gradient(
    143deg,
    #206cff 0%,
    rgba(52, 130, 202, 0.43) 100%
  );
  border-width: 3px;
  border-color: #206cff;
}

.purpleCard {
  background: linear-gradient(
    143deg,
    #7520ff 0%,
    rgba(181, 52, 202, 0.43) 100%
  );
}

.card-header {
  padding: 23px 16px 23px 16px;
  gap: 8px;
  color: white;
}

.header-text {
  font-size: 1.5rem;
  margin: 0;
}

.price-text {
  font-size: 1.5rem;
  margin: 0;
}
.card-body {
  background-color: white;
  padding: 20px;
  text-align: start;
}

.card-body p {
  color: #000;
}

.trainingList .yellowCard .btndftr {
  background-color: #f2c94c;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px 16px;
  width: 100%;
  height: 40px;
}

.trainingList .greenCard .btndftr {
  background-color: #30957d;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px 16px;
  width: 100%;
  height: 40px;
}

.trainingList .blueCard .btndftr {
  background-color: #206cff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px 16px;
  width: 100%;
  height: 40px;
}

.trainingList .purpleCard .btndftr {
  background-color: #7521ff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px 16px;
  width: 100%;
  height: 40px;
}

@media screen and (min-width: 800px) and (max-width: 1199px) {
  .trainingList .trainingJenis .card {
    float: left !important;
    width: calc(50% - 15px) !important;
  }
  .trainingList .trainingJenis .card:nth-child(even) {
    margin-left: 15px !important;
  }
  .trainingList .trainingJenis .card:nth-child(odd) {
    margin-right: 15px !important;
  }
}

@media screen and (min-width: 1200px) {
  .trainingList .trainingJenis .card {
    float: left !important;
    width: calc(25% - 15px) !important;
  }

  .trainingList .trainingJenis .card {
    margin-left: 15px !important;
  }
  .trainingList .trainingJenis .card:first-child {
    margin-left: 0px !important;
  }
}

.trainingList .header-text {
  font-size: 16px !important;
}

.trainingList .price-text {
  font-size: 22px !important;
}
.trainingList .price-text span {
  font-size: 12px !important;
}
.trainingList .card-body p,
.trainingList .card-body .list-text {
  font-size: 14px !important;
}
</style>
